export const BadRequest: number = 400;
export const Unauthorized: number = 401;
export const NotFound: number = 404;
export const Conflict: number = 409;
export const Forbidden: number = 403;
export const Unknown: number = 0;
export const GatewayTimeout: number = 504;